<template>
  <div class="phone-validation">
    <div v-show="validate.phone.step === 1">
      <form @submit.stop.prevent="handlePhone">
        <div class="form-group col-12">
          <p v-translate>Enter your mobile phone number</p>
          <cleave ref="phoneInput" :placeholder="$gettext('Enter your mobile phone number')" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="validate.phone.number" required></cleave>
        </div>
        <b-row>
          <div class="text-center form-group col-12 form-actions">
            <b-button type="submit" variant="primary" size="lg" v-translate>Send verification code via SMS</b-button>
            <b-button type="button" variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Cancel</b-button>
          </div>
        </b-row>
      </form>
    </div>
    <div v-show="validate.phone.step === 2">
      <form @submit.stop.prevent="handleCode">
        <div class="form-group col-12">
          <p v-translate>Enter the code</p>
          <b-input ref="code" class="form-control" type="number" v-model="validate.phone.code" required />
          <small id="emailHelp" class="form-text text-muted"><translate>Didn't receive the code SMS?</translate> <a href="#" @click.prevent="handlePhone" v-translate>Send a new code</a></small>
        </div>
        <b-row>
          <div class="text-center form-group col-12 form-actions">
            <b-button type="submit" variant="primary" size="lg" v-translate>Verify phone</b-button>
            <b-button type="button" variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Cancel</b-button>
          </div>
        </b-row>
      </form>
    </div>
  </div>
</template>
<script>
import Cleave from 'vue-cleave'

export default {
  name: 'PhoneValidation',
  components: {
    Cleave
  },
  props: {
    userId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      validate: {
        phone: {
          number: '+' + this.$cookies.get('phonePrefix'),
          step: 1,
          code: null
        }
      }
    }
  },
  methods: {
    handlePhone(evt) {
      evt.preventDefault()
      if (!this.validate.phone.number) {
        let obj = {
          title: this.$gettext('ERROR'),
          message: this.$gettext('Please enter your phone number'),
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      } else {
        this.handlePhoneSubmit()
      }
    },
    handlePhoneSubmit() {
      this.$http.post(this.$appConfig.api.baseUrl + 'sms-verification', { phone: this.validate.phone.number.replace(/\s|-|_|\./g, '') })
        .then(response => {
          this.validate.phone.step = 2
        }, error => {
          console.log(error)
          let message = ''
          if (error.status === 422) {
            for (let i = 0; i < error.body.errors.length; i++) {
              message += '- ' + error.body.errors[i].detail + '<br>'
            }
          } else {
            message = error.body.message
          }
          let obj = {
            title: this.$gettext('ERROR'),
            message: message,
            type: 'error'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        }).then(() => {
          this.$refs.code.focus()
        })
    },
    handleCode(evt) {
      evt.preventDefault()
      if (!this.validate.phone.code) {
        let obj = {
          title: this.$gettext('ERROR'),
          message: this.$gettext('Please enter the code'),
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      } else {
        this.handleCodeSubmit()
      }
    },
    handleCodeSubmit() {
      this.$http.post(this.$appConfig.api.baseUrl + 'users/phones/verify', { user_id: this.userId || this.$store.getters.uid, phone: this.validate.phone.number.replace(/\s|-|_|\./g, ''), code: this.validate.phone.code })
        .then(response => {
          // Success!
          this.emitSuccess()
        }, error => {
          let obj = {
            title: this.$gettext('ERROR'),
            message: error.body.message,
            type: 'error'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    },
    emitCancel() {
      this.$emit('cancel')
    },
    emitSuccess() {
      this.$emit('success')
    }
  }
}

</script>
